import "types/gtm";

/**
 * Pushes an object onto the GTM dataLayer.
 *
 * @param params.eventPayload - Key-value payload to append to dataLayer.
 */
export function pushDataLayerEvent(params: { eventPayload: Record<string, unknown> }): void {
  const { eventPayload } = params;

  // Lazily create the queue GTM's bootstrap normally provides. When GTM is blocked or not yet
  // loaded (CSP, ad blocker, denied consent) events queue harmlessly instead of throwing and
  // tripping the app-wide ErrorBoundary.
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(eventPayload);
}

/**
 * Notifies GTM-managed tags that cookie consent preferences changed.
 *
 * @param params.analyticsGranted - Whether analytics cookies were accepted.
 * @param params.marketingGranted - Whether marketing cookies were accepted.
 */
export function pushCookieConsentUpdateDataLayerEvent(params: {
  analyticsGranted: boolean;
  marketingGranted: boolean;
}): void {
  const { analyticsGranted, marketingGranted } = params;

  pushDataLayerEvent({
    eventPayload: {
      event: "cookie_consent_update",
      analytics_storage: analyticsGranted ? "granted" : "denied",
      ad_storage: marketingGranted ? "granted" : "denied",
    },
  });
}

/**
 * Notifies GTM-managed tags of a client-side route change.
 *
 * @param params.pagePath - Current pathname and search string.
 * @param params.pageTitle - Current document title.
 */
export function pushPageViewDataLayerEvent(params: { pagePath: string; pageTitle: string }): void {
  const { pagePath, pageTitle } = params;

  pushDataLayerEvent({
    eventPayload: {
      event: "page_view",
      page_path: pagePath,
      page_title: pageTitle,
    },
  });
}
